import { render } from "./ChapFail.vue?vue&type=template&id=1672d019&scoped=true"
import script from "./ChapFail.vue?vue&type=script&lang=js"
export * from "./ChapFail.vue?vue&type=script&lang=js"

import "./ChapFail.vue?vue&type=style&index=0&id=1672d019&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1672d019"]])

export default __exports__